/*eslint-disable no-template-curly-in-string*/
import React, { useState, useRef, useEffect } from 'react';
import './Course.css';
import { useParams, useHistory } from 'react-router-dom';
import { Input, Button, Progress, Alert, Select } from 'antd';
import { Form } from 'antd';
import { createSandbox } from './sandbox';
import { Navbar } from './Navbar';
import { Header } from './Header';
import Iframe from 'react-iframe';
import * as config from './config';


const apiUrl = '/api/v1/sandbox';

export const Course = (props:any) => {
  const qs = new URLSearchParams(window.location.search);
  let { id } = useParams<{id: string}>();
  const [progress, setProgress] = useState<number>(0);
  const [error, setError] = useState<Error|null>(null);
  const [email, setEmail] = useState<string|null>(qs.get('email'));
  const [ttl, setTtl] = useState<string|null>(qs.get('ttl'));
  const [verificationCode, setVerificationCode] = useState<string|null>(qs.get('code'));
  const containerRef = useRef<HTMLDivElement>(null);
  const history = useHistory();
  const fromDemo = config.demoHosts.includes(window.location.hostname);

  const [form] = Form.useForm();
  const refHostGet = (): string => {
    // console.log(`Doc: ${JSON.stringify(document)}`);

    if ( document?.referrer ) {
      const referrer = new URL(document.referrer.toString())

      //const referer = new URL(req.headers.referer.toString());
      return referrer.hostname;
    } else if ( window.location?.hostname ) {
      return window.location.hostname;
    } else {
      return "localtest.me";
    }
  }
  const refHost = refHostGet();
  console.log(`RefHost: ${refHost}`);

  // define startSandbox() for later use...
  const startSandbox = async () => {

    let localProgress = 0;
    const updateProgress = setInterval(() => {
      localProgress = localProgress + 100/sec;
      setProgress(localProgress);
    }, 1000);
    let host;
  
    try {
      host = await createSandbox(email, id, sec, verificationCode, ttl, refHost);
    } catch (err) {
      clearInterval(updateProgress);
      if (err instanceof Error) {
        setError(err);
      }
      setProgress(0);
      return;
    }
    window.ga('send', 'event', 'Sandbox', 'start', course);
    history.push(`/ui/`, {
      id,
      host,
      email,
      course,
      });
  }
  
  if (email) form.setFieldsValue({ email });
  if (fromDemo && ttl) form.setFieldsValue( { ttl });

  if (verificationCode) form.setFieldsValue({ verificationCode });
  const course = window.courses.find(c => c.id===id);
  useEffect(() => {
    if (email && !progress && !error) {
      if (config.noValidateTypes.includes(course.type) || config.noValidateSites.includes(refHost) || verificationCode) {
        startSandbox();
      }
    }
  });

  useEffect(() => { window.scrollTo(0, 0); }, []);



  const sec = course?.startupTime || 90;
  const outline = course?.outline;
  const submit = (values: any) => {
    setProgress(0);
    setError(null);
    if (values.email) {
      setEmail(values.email);
    }
    if (values.verificationCode) {
      setVerificationCode(values.verificationCode);
    }
    if (fromDemo && values.ttl) {
      setTtl(values.ttl);
    }
  };
  if (!course) {
    throw new Error(`Course ${id} not found`);
  } else if (email && !verificationCode && !error && !config.noValidateTypes.includes(course.type) && !config.noValidateSites.includes(refHost) ) {
    fetch(`${apiUrl}/requesttoken`, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    })
    .then(response => {
      if (!response.ok) {
        return response.text().then(errText => { throw new Error(errText) });
      }
    })
    .catch(err => { 
      if (err instanceof Error) {
        setError(err);
      }
    });
  } 


  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: 'Please enter a valid email address.',
    }
  };

  let initialSelectedOutlineItemId = outline ? outline.find(item => item.type === 'item') : undefined
  const [selectedOutlineItemId, setSelectedOutlineItem] = useState(initialSelectedOutlineItemId?.id ?? '')
  const selectedOutlineItem = selectedOutlineItemId ? outline?.find(item => item.type === 'item' && item.id === selectedOutlineItemId) : undefined;

  let buttonText = 'Get Verification Code';
  if (email || config.noValidateTypes.includes(course.type) || config.noValidateSites.includes(refHost)) buttonText = 'Start Sandbox';

  const ttlopts = [
    { value: '43200', label: "12 Hours"},
    { value: '86400', label: "1 day"},
    { value: '604800', label: "1 week"}
  ];

  return <div ref={containerRef} className="course__container">
    <Navbar />
    <Header
      backUrl="/"
      backLabel={ fromDemo ? "Back to Demos" : "Back to Sandboxes"} 
      description={
        <div dangerouslySetInnerHTML={{ __html: course?.description || '' }} />
      }
      imageUrl={course?.imageUrl}
      imageWidth={course?.imageWidth}

    >
      <Form form={form} onFinish={submit} layout='inline' className="course__form" name="sandbox" validateMessages={validateMessages}>
        <Form.Item name={'email'} label="Email" rules={[{ type: 'email', required: true }]}>
          <Input style={{width:300, marginRight:5, marginBottom: 10}} placeholder="Email address" value={email || ''}/>
        </Form.Item>
        { fromDemo &&
        <Form.Item name={'ttl'} label="Time to Live">
          <Select options={ttlopts} defaultValue={ ttl || '86400' } />
        </Form.Item>}
        {
          email && ! config.noValidateTypes.includes(course.type) && !config.noValidateSites.includes(refHost) &&
          <Form.Item name={'verificationCode'} label="Verification Code">
            <Input style={{width:300, marginRight:5, marginBottom: 10}} placeholder="Verification code" value={verificationCode || ''}/>
          </Form.Item>
        }
        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={(verificationCode || '').length > 0 && !error}>{buttonText}</Button>
        </Form.Item>
      </Form>
      { 
        (email && !verificationCode && !error  && ! config.noValidateTypes.includes(course.type)) && !config.noValidateSites.includes(refHost) && 
        <div className="course__verificationCode">Check your email for a verification code!</div>
      }
      {
        progress>0 &&
        <div className="course__progress">
          <span>Sandbox starting... Expected time: {sec} seconds</span>
          <Progress percent={Math.round(progress)} status="active" />
        </div>
      }
      {
        error &&
        <Alert type="error" showIcon message={`Error received while creating sandbox: ${error.message}`} />
      }
    </Header>
    { !fromDemo &&
    <div id='previewheader' className='wrapped'><h1>Course Preview</h1></div>
    }
    { !fromDemo &&
    <div id='iframeContainer' style={{ height: 800 }}>
      <Iframe url={`/coursedocs/${course?.id}/docs/intro1`}
        id="docsIframe"
        height="100%"
        width="100%"
      />
    </div>}
  </div>;
}
